// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Устанавливаем общие стили для страницы */
html, body {
    height: 100%; /* Устанавливаем высоту на 100% */
    margin: 0;    /* Убираем отступы */
    background-color: #ffffff; /* Фон страницы */
    /* background-image: url('/src/modules/Courier/img/1.jpg'); */
    
}

/* 1) В самом корне занимать весь экран */
.app-container {
  display: flex;
  flex-direction: column;
  height: 100vh;   /* всё окно браузера */
  overflow: hidden;/* шапка и футер не подскролливаются */
}

/* 2) Промежуточный контейнер, в котором появится скролл */
.space-container {
  flex: 1 1;         /* займёт всё пространство между шапкой и футером */
  overflow: hidden;
  /* если нужно отступать от самого верха и низа, можно оставить padding */
  padding-top: 45px;   
  padding-bottom: 75px;
  box-sizing: border-box;
}

@media (min-width: 768px) {
  .space-container {
    padding-bottom: 0; /* контент теперь растягивается до самого низа */
  }


}

/* 3) Собственно контент, внутри которого всё равномерно растянется */
.content-container {
  /* он уже растягивается на всю доступную высоту space-container */
  width: 100%;
  overflow-y: auto;
  box-sizing: border-box;
  /*border: 100px solid rgb(0, 0, 0);  Граница синего цвета */

}


  













`, "",{"version":3,"sources":["webpack://./src/styles/global.css"],"names":[],"mappings":"AAAA,2CAA2C;AAC3C;IACI,YAAY,EAAE,iCAAiC;IAC/C,SAAS,KAAK,oBAAoB;IAClC,yBAAyB,EAAE,iBAAiB;IAC5C,6DAA6D;;AAEjE;;AAEA,yCAAyC;AACzC;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa,IAAI,sBAAsB;EACvC,gBAAgB,CAAC,sCAAsC;AACzD;;AAEA,0DAA0D;AAC1D;EACE,SAAO,UAAU,mDAAmD;EACpE,gBAAgB;EAChB,wEAAwE;EACxE,iBAAiB;EACjB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE;IACE,iBAAiB,EAAE,gDAAgD;EACrE;;;AAGF;;AAEA,qEAAqE;AACrE;EACE,iEAAiE;EACjE,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,2DAA2D;;AAE7D","sourcesContent":["/* Устанавливаем общие стили для страницы */\r\nhtml, body {\r\n    height: 100%; /* Устанавливаем высоту на 100% */\r\n    margin: 0;    /* Убираем отступы */\r\n    background-color: #ffffff; /* Фон страницы */\r\n    /* background-image: url('/src/modules/Courier/img/1.jpg'); */\r\n    \r\n}\r\n\r\n/* 1) В самом корне занимать весь экран */\r\n.app-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  height: 100vh;   /* всё окно браузера */\r\n  overflow: hidden;/* шапка и футер не подскролливаются */\r\n}\r\n\r\n/* 2) Промежуточный контейнер, в котором появится скролл */\r\n.space-container {\r\n  flex: 1;         /* займёт всё пространство между шапкой и футером */\r\n  overflow: hidden;\r\n  /* если нужно отступать от самого верха и низа, можно оставить padding */\r\n  padding-top: 45px;   \r\n  padding-bottom: 75px;\r\n  box-sizing: border-box;\r\n}\r\n\r\n@media (min-width: 768px) {\r\n  .space-container {\r\n    padding-bottom: 0; /* контент теперь растягивается до самого низа */\r\n  }\r\n\r\n\r\n}\r\n\r\n/* 3) Собственно контент, внутри которого всё равномерно растянется */\r\n.content-container {\r\n  /* он уже растягивается на всю доступную высоту space-container */\r\n  width: 100%;\r\n  overflow-y: auto;\r\n  box-sizing: border-box;\r\n  /*border: 100px solid rgb(0, 0, 0);  Граница синего цвета */\r\n\r\n}\r\n\r\n\r\n  \r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
